import { useEffect } from 'react';
import { useLazyGetContentListQuery } from '@api/api';
import { ContentRequest } from '@api/types';
import { BlockEditorTitle, ContentArea, Progress } from '@components';
import { useAppDispatch, useEditMode } from '@hooks';
import { setBlockEdit } from '@store/edit/edit.slice';

export const BlockEditor = () => {
  // Get current content id
  // Draft id consist of contentId and workId
  // E.g. 12_345
  const { contentId, workId, subscribe } = useEditMode();
  let subscription = null as any;

  // Update store
  const dispatch = useAppDispatch();

  // DATA FETCH
  // Setup RTK Query lazy fetch
  const [trigger, status] = useLazyGetContentListQuery();
  const { isLoading, currentData } = status;

  // Fetch fresh data from EPI
  const fetchData = (e?: any) => {
    const id = e?.contentLink || `${contentId}_${workId}`;
    const references = [id];
    const request: ContentRequest = { references, epiEditMode: true, expand: '*' };
    trigger(request);
  };

  // Content Saved handler
  const updateDataOnSave = (e: any) => {
    if (window.epi.isEditable) {
      fetchData(e);
    }
  };

  // Initial data load
  useEffect(() => {
    fetchData();
    dispatch(setBlockEdit(true));
    if (!subscription) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      subscription = subscribe('contentSaved', updateDataOnSave);
    }
  }, []);

  return (
    <>
      {isLoading && <Progress />}
      <BlockEditorTitle content={currentData} />
      <ContentArea content={currentData} epiEditMode />
    </>
  );
};
